<template>
  <div>
      <div >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <div>
              <el-row>
                <el-col>
                    <el-form-item label="移除时间" prop="">
                        <el-date-picker type="date" v-model="ruleForm.remove_date" value-format="yyyy-MM-dd" style="width:85%"></el-date-picker>
                    </el-form-item>
                    </el-col>
              </el-row>

              <el-row>
                <el-col>
                  <el-form-item label="操作人" prop="">
                    <el-input style="width:85%" v-model="$globals.user.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-form-item label="移除原因" prop="">
                  <el-input type="textarea" :rows="2" placeholder="请输入移除原因" v-model="ruleForm.remove_reason" style="width:85%"></el-input>
                </el-form-item>
              </el-row>     
            </div>

            <el-form-item style="margin-left:80px">
                <el-button type="goon" @click="submitForm('ruleForm')">保存</el-button>

            </el-form-item>
            </el-form>
      </div>

  </div>
</template>

<script>
export default {
   data() {
      return {
        remove_date : new Date(),
        ruleForm:{
          id:'',
          remove_date:this.getNowTime(),
          operator:this.$globals.user.id,
          remove_reason:'',
        },
        rules: {
            remove_reason: [
            { required: true, message: '请输入移除原因', trigger: 'blur' },
          ],
        },
        
      };
    },
    methods: {
      //处理默认选中当前日期
	    getNowTime() {
	       var now = new Date();
	       var year = now.getFullYear(); //得到年份
	       var month = now.getMonth(); //得到月份
	       var date = now.getDate(); //得到日期
	       month = month + 1;
	       month = month.toString().padStart(2, "0");
	       date = date.toString().padStart(2, "0");
	       var defaultDate = `${year}-${month}-${date}`;
	       return defaultDate;
      },
      // 
            submitForm(ruleForm) {
               this.$refs[ruleForm].validate(async (valid) => {

                if (valid) {
                    var url = 'StaffBlacklist/update';
                    var record = {
                        ids: this.ruleForm.ids,
                        remove_date: this.ruleForm.remove_date,
                        operator: this.ruleForm.operator,
                        remove_reason: this.ruleForm.remove_reason,
                    };
                    var data = await this.$globals.AxiosPost(url, record);
                    if (data === '-2000') {
                        this.$message.error('服务器未响应！请稍后重试');
                    } else {
                        var code = data.code;
                        var data = data.data;
                        if (code === '200') {
                            this.$message.success(data);
                            this.$parent.$parent.trash();
                            this.$parent.$parent.dialogVisible = false;
                            this.$parent.$parent.Find();
                        } else {
                            this.$message.warning(data);
                        }
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
          });
        },
    },
    async created() {
            this.ruleForm = this.$parent.$parent.ruleForm;
        },
}
</script>

<style>
.el-checkbox__input.is-checked+.el-checkbox__label{
    color: #006E4B;
}
.el-input{
    width: 80%;
}

</style>


// WEBPACK FOOTER //
// Hmdgl_yichu.vue?afd7de1a